/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useStyles } from './styles';
import { getCollection } from 'utils';
import { Collections, isMobile } from 'app-constants';
import { Grid, Box } from '@material-ui/core';
import { Loader, CopyRight, MediaCard, TextWithSubtitle, AppCarousel } from 'components';
// import { gallery as mockGallery } from '../../mocks/gallery';
import { useSelector, useDispatch } from 'react-redux';
import { UserPrefferenceActions } from 'reducers';
import FilterButtons from './Components/FilterButtons/FilterButtons';
import { useTranslation } from 'react-i18next';

function ImageGallery() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [currentImage, setCurrentImage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [gallery, setGallery] = useState([]);
  const [filteredGallery, setFilteredGallery] = useState(gallery);

  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const isListView = useSelector((state) => state.userPrefference.isListView);
  const filterMode = useSelector((state) => state.userPrefference.filterMode);

  const setSelectedMode = (mode) => {
    dispatch(UserPrefferenceActions.setFilterMode(mode));
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
    filterGalleryByMode(gallery, mode);
  };

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const filterGalleryByMode = (galleryData, mode) => {
    if (mode === 'all') {
      setFilteredGallery(galleryData);
    }
    if (mode === 'available') {
      setFilteredGallery(galleryData.filter((product) => product.available && !product.booked));
    }
    if (mode === 'booked') {
      setFilteredGallery(galleryData.filter((product) => product.booked));
    }
    if (mode === 'sold') {
      setFilteredGallery(galleryData.filter((product) => !product.available));
    }
  };

  useEffect(() => {
    const unsubscribe = getCollection(Collections.GALLERY).onSnapshot(async (data) => {
      const galleryData = await data.docs.map((doc) => {
        const obj = { ...doc.data() };
        obj.id = doc.id;
        return obj;
      });
      filterGalleryByMode(galleryData, filterMode);
      if (galleryData.length) {
        setIsLoading(false);
        setGallery(galleryData);
      }
    });
    return () => unsubscribe();
  }, [filterMode]);

  return (
    <div className={classes.root}>
      <div className={classes.toolbar} />
      <br />
      <Loader isLoading={isLoading} />
      <TextWithSubtitle noBr={isMobile} variant="h6" title={t('handmade')} />
      <AppCarousel
        viewerIsOpen={viewerIsOpen}
        currentImage={currentImage}
        closeLightbox={closeLightbox}
        gallery={filterMode === 'all' ? gallery : filteredGallery}
      />
      <div className={classes.root}>
        <FilterButtons selectMode={setSelectedMode} filterMode={filterMode} />
        <br />
        {filteredGallery.length ? (
          <TextWithSubtitle subtitle={`${t('filter-found-results')} - ${filteredGallery.length}`} />
        ) : !isLoading ? (
          <TextWithSubtitle title={t('filter-no-results')} />
        ) : null}
        <Grid alignItems="center" justify="center" container spacing={!isListView && isMobile ? 1 : 2}>
          {filterMode
            ? filteredGallery.map((photo, index) => (
                <Grid key={photo.id} item xs={!isListView && isMobile ? 6 : 'auto'}>
                  <MediaCard index={index} handleOpenCarousel={openLightbox} data={photo} />
                </Grid>
              ))
            : gallery.map((photo, index) => (
                <Grid key={photo.id} item xs={!isListView && isMobile ? 6 : 'auto'}>
                  <MediaCard index={index} handleOpenCarousel={openLightbox} data={photo} />
                </Grid>
              ))}
        </Grid>

        {gallery.length && filteredGallery.length ? (
          <Box mt={2}>
            <CopyRight />
          </Box>
        ) : null}
      </div>
    </div>
  );
}

export default ImageGallery;
